import {observable, action, computed} from "mobx";
import FabricModel from "./FabricModel";
import { StoreClass } from "../stores/Store";



export default class FabricCollectionModel {
    store: StoreClass;
    @observable id = null;
    @observable name = null;
    @observable price = 0;
    @observable data: FabricCollectionDataType = {};
    @computed get attributes(): FabricAttributes {
        return this.data.attributes;
    }

    @computed get badge(){
        return this.getExtraDataAttribute('badge');
    }

    @computed get thumbUrl() {
        if (this.data.attributes?.thumb?.at(0)) {
            return this.data.attributes.thumb.at(0);
        }
        return null;
    }
    filteredImageURL(colorsIds){ 
        if(colorsIds.length > 0){
            // find fabrics in orders defined by colorsIds 
            var thumbs = this.colorThumbs.filter((c) => colorsIds.includes(c.item_id));
            // filterout all that not exists in this.fabricsFiltered
            thumbs = thumbs.filter((c) => this.fabricsFiltered.find((f) => f.colorGroupIds.includes(c.item_id)));
            // sort by colorsIds, if not found in colorsIds goes to end
            thumbs = thumbs.sort((a, b) => colorsIds.indexOf(a.item_id) - colorsIds.indexOf(b.item_id));
            var color = thumbs.find((c) => colorsIds.includes(c.item_id));
            if(color){
                return color.media;
            }

             // find fabrics in orders defined by colorsIds 
            var sortKey = (f) => {
                const idx = colorsIds.findIndex(id => f.colorGroupIds.includes(id));
                return idx === -1 ? colorsIds.length : idx;
            };
            var fabric = this.fabricsFiltered
            .toSorted((f1, f2) => sortKey(f1) - sortKey(f2))
            .find((f) => f.colorGroupIds.some(id => colorsIds.includes(id)));
            if(fabric){
                return fabric.thumbUrl;
            }
        }
        return this.thumbUrl;
    }
    @computed get sampler_video_url() {
        if (this.data.attributes?.sampler_video_url) {
            return this.data.attributes.sampler_video_url;
        }
        return null;
    }
    @computed get description() {
        if (this.data.attributes?.description) {
            return this.data.attributes.description;
        }
        return null;
    }
    @computed get pdfUrl() {
        if (this.data.attributes?.pdf?.at(0)) {
            return this.data.attributes.pdf.at(0);
        }
        return null;
    }
    @computed get fabricFeatures():Array<{id:Number, name: String}> {
        if (this.store && this.attributes?.fabric_features?.length > 0) {
            const ids = this.attributes.fabric_features;
            return this.store.fabric_features.filter((f) => ids.includes(f.id));
        }
        return [];
    }

    @computed get technicalCardProperties():Array<{id:Number, name: String, value: String}> {
        if (this.store && this.attributes?.technical_card_properties?.length > 0) {
            return this.attributes.technical_card_properties.map((f, i) => {
                return {
                    id: f.id || i,
                    name: f.name,
                    value: f.value,
                }
            });
        }
        return [];
    }

    @computed get fabricProperties():Array<{id:Number, value: String, iconName: String, tooltip: String}> {
        if (this.store && this.attributes?.fabric_properties?.length > 0) {
            const ids = this.attributes.fabric_properties;
            return this.store.fabric_properties.filter((f, i) => ids.includes(f.id)).map((f) => {
                return {
                    id: f.id,
                    value: f.name,
                    iconName: f.attributes.icon_name,
                    tooltip: f.attributes.tooltip
                }
            })
        }
        return [];
    }

    @computed get febricColorsIds(): Number[] {
        if (this.fabrics.length > 0) {
            return this.fabrics.reduce((acc, fabric) => {
                fabric.colorGroupIds.forEach(id => {
                    if(!acc.includes(id) && id){
                        acc.push(id);
                    }
                });
                return acc;
            }, []);
        }
        return [];
    }


    /**
     * Contains internal admin_id
     */
    @computed get fabricsIds():Number[] {
        if(this.attributes?.fabrics?.length > 0){
            return this.attributes.fabrics;
        }
        return [];
    }
    @computed get fabrics(): FabricModel[]{
        if (this.store?.fabrics?.length > 0) {
            return this.store?.fabrics.filter((fabric) =>
                this.fabricsIds.includes(fabric.id)
            ).toSorted((a, b) => {
                const numA = parseInt(String(a.name).match(/\d+/)[0] || 0, 10);
                const numB = parseInt(String(b.name).match(/\d+/)[0] || 0, 10);
                return numA - numB;
            });
        }
        return [];
    }
    @computed get fabricsFiltered(): FabricModel[]{
        return this.fabrics.filter((f) => {
            var isSelectedColor = true;
            var colorsIds = this.store.fabricFilters.getFilterValue("colors");
            if(colorsIds.length > 0){
                isSelectedColor = f.colorGroupIds.some(id => colorsIds.includes(id));
            }
            return isSelectedColor;
        });
        return [];
    }

    @computed get colorThumbs(): Array<{item_id: number, media: string, item_name: string}> {
        return this.attributes?.color_thumbs || [];
    }

    @computed get priority() {
        return this.data.priority;
    }
    /**
     *
     * @param {FabricDataType} props
     */
    constructor({ store, ...props }) {
        if (!store) {
            throw Error(`store is undefined`);
        }
        this.store = store;

        this.fromJSON(props);
        // this.category = props.category;
    }

    getExtraData(name){
        if(this.data.ch_extra_data?.items.length > 0 && this.data.extraData[name] !== undefined){
            return this.data.ch_extra_data.items[0][name];
        }
        return null;
    }
    getExtraDataAttribute(name) {
        const attributes = this.getExtraData("attributes");
        if (attributes && attributes[name] !== undefined) {
            return attributes[name];
        }
        return null;
    }

    fromJSON(props) {
        this.data = props;
        this.name = props.name;
        this.id = parseInt(props.id);
        if(isNaN(this.id)){
            throw Error('id is not a number ' + this.id);
        }
        // var p = this.getExtraData('price');
        if(this.fabrics.at(0)){
            this.price = this.fabrics.at(0).price;
        }
    }

    static create(data) {
        return new FabricCollectionModel(data);
    }
}


export class TechnicalCardAttributes{
    id = 0;
    name = 'Undefined';
    attributes:Object<{name: String, value: String}> = [];
}

export class FabricAttributes {
    fabric_features: Number[] = [];
    fabric_properties: Number[] = [];
    fabrics: Number[] = [];
    thumb: String[] = [];
    pdf: String[] = [];
    sampler_video_url: String[] = [];
    description: String = "";
    technical_card_properties: TechnicalCardAttributes[] = [];
}

export class FabricCollectionDataType {
    id = 0;
    name = "Undefined";
    image = null;
    price = 0;
    attributes: FabricAttributes = [];
}